import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import _merge from "lodash/merge";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
import "core-js/modules/es.array.map.js";
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import { useState, useRef, useEffect } from 'react';
import classnames from 'classnames';
import { SliceIntroBlock, defaultPropsSliceIntroBlock } from "../../Block/SliceIntroBlock/SliceIntroBlock";
import { Container } from "../../Container/Container/Container";
import { Theme } from "../../Background/Theme/Theme";
import { defaultThemeContext } from "../../../context/theme.context";
import { Background } from "../../Background/Background";
import { Text } from "../../Text/Text/Text";
import { Breakpoints } from "../../Responsive/Breakpoints/Breakpoints";
import styles from "./VideoSlideshowSlice.module.scss";
import SwiperCore, { EffectFade, Autoplay, A11y } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/swiper-bundle.min.css';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
SwiperCore.use([EffectFade, Autoplay, A11y]);
export var videoSlideshowSliceTextLocation = ['left', 'center'];
var posRules = {
  top: 'flex-start',
  center: 'center',
  bottom: 'flex-end'
};
var defaultDesktopHeight = 600;
var defaultMobileHeight = 500;
var defaultSlideShowConfig = {
  duration: 3000,
  desktopHeight: defaultDesktopHeight,
  mobileHeight: defaultMobileHeight,
  theme: defaultThemeContext,
  scrimOpacity: 0.65,
  textLocation: 'left'
};
export var VideoSlideshowSlice = function VideoSlideshowSlice(_ref) {
  var _ref$slideshowConfig = _ref.slideshowConfig,
    slideshowConfig = _ref$slideshowConfig === void 0 ? defaultSlideShowConfig : _ref$slideshowConfig,
    align = _ref.align,
    _ref$intro = _ref.intro,
    intro = _ref$intro === void 0 ? defaultPropsSliceIntroBlock : _ref$intro,
    _ref$introPosition = _ref.introPosition,
    introPosition = _ref$introPosition === void 0 ? 'center' : _ref$introPosition,
    _ref$slides = _ref.slides,
    slides = _ref$slides === void 0 ? [] : _ref$slides;
  var _useState = useState('mobile'),
    _useState2 = _slicedToArray(_useState, 2),
    breakpoint = _useState2[0],
    setBreakpoint = _useState2[1];
  var swiperRef = useRef(null);
  var setSliceBreakpoint = function setSliceBreakpoint() {
    var currentBreak = swiperRef.current ? Breakpoints.small.min > window.innerWidth ? 'mobile' : 'desktop' : null;
    setBreakpoint(currentBreak);
  };
  useEffect(function () {
    if (window) {
      setSliceBreakpoint();
      window.addEventListener('resize', setSliceBreakpoint);
      return function () {
        var _swiperRef$current, _swiperRef$current$sw;
        swiperRef === null || swiperRef === void 0 ? void 0 : (_swiperRef$current = swiperRef.current) === null || _swiperRef$current === void 0 ? void 0 : (_swiperRef$current$sw = _swiperRef$current.swiper.autoplay) === null || _swiperRef$current$sw === void 0 ? void 0 : _swiperRef$current$sw.stop();
        window.removeEventListener('resize', setSliceBreakpoint);
      };
    }
  }, []);
  var pauseCarousel = function pauseCarousel() {
    var _swiperRef$current2, _swiperRef$current2$s;
    return swiperRef === null || swiperRef === void 0 ? void 0 : (_swiperRef$current2 = swiperRef.current) === null || _swiperRef$current2 === void 0 ? void 0 : (_swiperRef$current2$s = _swiperRef$current2.swiper) === null || _swiperRef$current2$s === void 0 ? void 0 : _swiperRef$current2$s.autoplay.stop();
  };
  var playCarousel = function playCarousel() {
    var _swiperRef$current3, _swiperRef$current3$s;
    return swiperRef === null || swiperRef === void 0 ? void 0 : (_swiperRef$current3 = swiperRef.current) === null || _swiperRef$current3 === void 0 ? void 0 : (_swiperRef$current3$s = _swiperRef$current3.swiper) === null || _swiperRef$current3$s === void 0 ? void 0 : _swiperRef$current3$s.autoplay.start();
  };
  var renderCarouselItems = function renderCarouselItems() {
    var _ref2 = slideshowConfig || {},
      desktopHeight = _ref2.desktopHeight,
      mobileHeight = _ref2.mobileHeight,
      theme = _ref2.theme,
      scrimOpacity = _ref2.scrimOpacity,
      duration = _ref2.duration,
      textLocation = _ref2.textLocation;
    var buttonLocation = {
      bottom: '10px',
      right: '10px'
    };
    var overrides = {
      background: {
        theme: theme,
        video: {
          desktop: {
            onPause: function onPause() {
              return pauseCarousel();
            },
            onPlay: function onPlay() {
              return playCarousel();
            },
            height: desktopHeight,
            scrimOpacity: scrimOpacity,
            buttonLocation: buttonLocation
          },
          mobile: {
            onPause: function onPause() {
              return pauseCarousel();
            },
            onPlay: function onPlay() {
              return playCarousel();
            },
            height: mobileHeight,
            scrimOpacity: scrimOpacity,
            buttonLocation: buttonLocation
          }
        }
      }
    };
    var slideTheme = theme ? theme : defaultSlideShowConfig.theme;
    return slides === null || slides === void 0 ? void 0 : slides.map(function (item, key) {
      var controlledItem = _merge({}, item, overrides);
      return /*#__PURE__*/_jsx(SwiperSlide, {
        className: "swiper-no-swiping",
        "data-swiper-autoplay": duration,
        children: /*#__PURE__*/_jsx(Background, _objectSpread(_objectSpread({}, controlledItem.background), {}, {
          children: /*#__PURE__*/_jsx("div", {
            className: classnames(styles["".concat(textLocation)], styles.slideText),
            children: /*#__PURE__*/_jsx(Theme, {
              theme: slideTheme,
              children: /*#__PURE__*/_jsx(Text, {
                richText: true,
                typog: "bodycopy",
                children: item.text
              })
            })
          })
        }))
      }, key);
    });
  };
  var renderIntro = function renderIntro() {
    var _ref3 = slideshowConfig || {},
      desktopHeightConfig = _ref3.desktopHeight,
      mobileHeightConfig = _ref3.mobileHeight;
    var introData = _merge(intro, {
      align: align
    });
    var position = {
      justifyContent: posRules[introPosition] || 'center'
    };
    var desktopHeight = typeof desktopHeightConfig === 'number' ? desktopHeightConfig : defaultDesktopHeight;
    var mobileHeight = typeof mobileHeightConfig === 'number' ? mobileHeightConfig : defaultMobileHeight;
    var height = (breakpoint === 'desktop' ? desktopHeight : mobileHeight) - 50;
    return /*#__PURE__*/_jsx(Container, {
      className: styles.introContainerWrapper,
      inlineStyle: {
        height: "".concat(height, "px")
      },
      innerClassName: styles.introBlockContainer,
      innerInlineStyle: position,
      children: /*#__PURE__*/_jsx(Background, {
        theme: slideshowConfig !== null && slideshowConfig !== void 0 && slideshowConfig.theme ? slideshowConfig.theme : defaultSlideShowConfig.theme,
        children: /*#__PURE__*/_jsx(SliceIntroBlock, _objectSpread(_objectSpread({}, introData), {}, {
          className: styles.introBlock
        }))
      })
    });
  };
  return /*#__PURE__*/_jsxs("div", {
    className: styles.videoSlideshowWrapper,
    children: [renderIntro(), /*#__PURE__*/_jsx(Swiper, {
      ref: swiperRef,
      className: styles.carouselWrapper,
      slidesPerView: 1,
      modules: [EffectFade, Autoplay],
      effect: "fade",
      fadeEffect: {
        crossFade: true
      },
      loop: true,
      noSwiping: true,
      autoplay: {
        disableOnInteraction: false,
        waitForTransition: false
      },
      children: renderCarouselItems()
    })]
  });
};